export var DRAGGABLE_VALUES = Object.freeze({
  TRUE: 'true',
  FALSE: 'false',
  AUTO: 'auto'
});